import React from 'react';
import ManualReminder from '../../../../assets/images/institute/admissions/livefeatures/ManualReminder.png';
import ManualReminderMobile from '../../../../assets/images/institute/admissions/livefeatures/ManualReminderMobile.png';
import ManualReminderHover from '../../../../assets/images/institute/admissions/livefeatures/ManualReminderHover.png';
import DocumentUpload from '../../../../assets/images/institute/admissions/livefeatures/DocumentUpload.png';
import DocumentUploadMobile from '../../../../assets/images/institute/admissions/livefeatures/DocumentUploadMobile.png';
import DocumentUploadHover from '../../../../assets/images/institute/admissions/livefeatures/DocumentUploadHover.png';
import OfflineFeeCollection from '../../../../assets/images/institute/admissions/livefeatures/OfflineFeeCollection.png';
import OfflineFeeCollectionMobile from '../../../../assets/images/institute/admissions/livefeatures/OfflineFeeCollectionMobile.png';
import OfflineFeeCollectionHover from '../../../../assets/images/institute/admissions/livefeatures/OfflineFeeCollectionHover.png';
import CounsellorAssigment from '../../../../assets/images/institute/admissions/livefeatures/CounsellorAssigment.png';
import CounsellorAssigmentMobile from '../../../../assets/images/institute/admissions/livefeatures/CounsellorAssigmentMobile.png';
import CounsellorAssigmentHover from '../../../../assets/images/institute/admissions/livefeatures/CounsellorAssigmentHover.png';
import ApplicantProfileView from '../../../../assets/images/institute/admissions/livefeatures/ApplicantProfileView.png';
import ApplicantProfileViewMobile from '../../../../assets/images/institute/admissions/livefeatures/ApplicantProfileViewMobile.png';
import ApplicantProfileViewHover from '../../../../assets/images/institute/admissions/livefeatures/ApplicantProfileViewHover.png';
import classes from './LiveFeatures.module.scss';
import { CustomImage } from '../../../atoms';

const LiveFeatures = () => {
    return (
        <div className={classes.LiveFeatures}>
            <div className={classes.LiveFeatures__LiveFeatureSection}>
                <div className={classes.LiveFeatures__LiveFeatureHeader}>
                    <h4 className={classes.LiveFeatures__LiveFeatureHeading}>
                        <div className={classes.LiveFeatures__GreenDot} />
                        <div>
                            <span className={classes.FeatureWrapper__NormalText}>Live{' '}</span>
                            <span className={classes.FeatureWrapper__GradientText}>Features</span>
                        </div>
                    </h4>
                    <p className={classes.LiveFeatures__LiveFeatureDescription}>Helping you manage better</p>
                </div>
                <div className={classes.LiveFeatures__LiveFeatureContentBox}>
                    <div className={classes.LiveFeatures__Row1}>
                        <div className={classes.LiveFeatures__ManualReminder}>
                            <div className={classes.LiveFeatures__ImageSwap}>
                                <CustomImage
                                    title='ManualReminder'
                                    className={`${classes.LiveFeatures__FeatureImage} ${classes.LiveFeatures__ImageDefault}`}
                                    images={[
                                        {
                                            media: '468',
                                            src: ManualReminderMobile,
                                        }
                                    ]}
                                    lazy={false}
                                    defaultImg={ManualReminder}
                                />
                            </div>
                            <div className={`${classes.LiveFeatures__HoverContainer} ${classes.LiveFeatures__HoverContainer_PositionBottom}`}>
                                <h2 className={classes.LiveFeatures__HoverTitle}>Manual Reminder Triggers</h2>
                                <p className={classes.LiveFeatures__HoverDescription}>Set custom reminders for follow-ups and deadlines</p>
                            </div>
                        </div>
                    </div>
                    <div className={classes.LiveFeatures__Row2}>
                        <div className={classes.LiveFeatures__DocumentUpload}>
                            <CustomImage
                                title='DocumentUpload'
                                className={`${classes.LiveFeatures__FeatureImage} ${classes.LiveFeatures__ImageDefault}`}
                                images={[
                                    {
                                        media: '468',
                                        src: DocumentUploadMobile,
                                    }
                                ]}
                                lazy={false}
                                defaultImg={DocumentUpload}
                            />
                            <div className={`${classes.LiveFeatures__HoverContainer} ${classes.LiveFeatures__HoverContainer_PositionBottom}`}>
                                <h2 className={classes.LiveFeatures__HoverTitle}>Document Upload & Verification</h2>
                                <p className={classes.LiveFeatures__HoverDescription}>Secure document collection and verification system</p>
                            </div>
                        </div>
                        <div className={classes.LiveFeatures__OfflineFeeCollection}>
                            <CustomImage
                                title='OfflineFeeCollection'
                                className={`${classes.LiveFeatures__FeatureImage} ${classes.LiveFeatures__ImageDefault}`}
                                images={[
                                    {
                                        media: '468',
                                        src: OfflineFeeCollectionMobile,
                                    }
                                ]}
                                lazy={false}
                                defaultImg={OfflineFeeCollection}
                            />
                            <div className={`${classes.LiveFeatures__HoverContainer} ${classes.LiveFeatures__HoverContainer_PositionBottom}`}>
                                <h2 className={classes.LiveFeatures__HoverTitle}>Offline Fee Collection & Receipts</h2>
                                <p className={classes.LiveFeatures__HoverDescription}>Track payments and generate receipts for LiveFeatures</p>
                            </div>
                        </div>
                    </div>
                    <div className={classes.LiveFeatures__Row3}>
                        <div className={classes.LiveFeatures__CounsellorAssigment}>
                            <CustomImage
                                title='CounsellorAssigment'
                                className={`${classes.LiveFeatures__FeatureImage} ${classes.LiveFeatures__ImageDefault}`}
                                images={[
                                    {
                                        media: '468',
                                        src: CounsellorAssigmentMobile,
                                    }
                                ]}
                                lazy={false}
                                defaultImg={CounsellorAssigment}
                            />
                            <div className={`${classes.LiveFeatures__HoverContainer} ${classes.LiveFeatures__HoverContainer_PositionTop}`}>
                                <h2 className={classes.LiveFeatures__HoverTitle}>Counsellor Assignment</h2>
                                <p className={classes.LiveFeatures__HoverDescription}>Assign dedicated counsellors to student applications</p>
                            </div>
                        </div>
                        <div className={classes.LiveFeatures__ApplicantProfileView}>
                            <CustomImage
                                title='ApplicantProfileView'
                                className={`${classes.LiveFeatures__FeatureImage} ${classes.LiveFeatures__ImageDefault}`}
                                images={[
                                    {
                                        media: '468',
                                        src: ApplicantProfileViewMobile,
                                    }
                                ]}
                                lazy={false}
                                defaultImg={ApplicantProfileView}
                            />
                            <div className={`${classes.LiveFeatures__HoverContainer} ${classes.LiveFeatures__HoverContainer_PositionTop}`}>
                                <h2 className={classes.LiveFeatures__HoverTitle}>Applicant Profile View</h2>
                                <p className={classes.LiveFeatures__HoverDescription}>Detailed student information and application tracking</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LiveFeatures